const appConfig = {
  apiMiddleware: process.env.REACT_APP_BASE_URL_MDW,
  timerDurationMinutes: process.env.REACT_APP_OTP_EXP_MIN,
  maxRestartLimit: process.env.REACT_APP_OTP_ATTEMPT,
  restartDelayMinutes: process.env.REACT_APP_OTP_LOCKED_MIN,
  idleTimeout: process.env.REACT_APP_SESSION_TIMEOUT,
  program: process.env.REACT_APP_PROGRAM,
  debugMode: process.env.REACT_APP_DEBUG_MODE,
  AES_SK: process.env.REACT_APP_AES_SK,
  GOOGLE_CAPTCHA_SITE_KEY: process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY
}

export default appConfig
